import React from 'react';
import PropTypes from 'prop-types';
import SortSelect from '@pages/candidate/common/SortSelect';

export const ConnectCddEmpReceiverNeedFuSortOptions = {
    LATEST_SENT_TIME_ASC: {
        value: 'LATEST_SENT_TIME_ASC',
        label: 'Latest Sent Time cũ hơn hiển thị trước'
    },
    LATEST_SENT_TIME_DESC: {
        value: 'LATEST_SENT_TIME_DESC',
        label: 'Latest Sent Time mới hơn hiển thị trước'
    },
    BRIEF_SENT_ASC: {
        value: 'BRIEF_SENT_ASC',
        label: 'Số Brief Sent nhỏ hơn hiển thị trước'
    },
    BRIEF_SENT_DESC: {
        value: 'BRIEF_SENT_DESC',
        label: 'Số Brief Sent lớn hơn hiển thị trước'
    }
}

const ConnectCddEmpReceiverNeedFuSortComponent = ({ 
    value, 
    onChange,
    className,
    style
}) => {
    return (
        <SortSelect
            value={value}
            onChange={onChange}
            options={ConnectCddEmpReceiverNeedFuSortOptions}
            className={className}
            style={style}
            name="connectCddEmpReceiverNeedFuSort"
        />
    );
};

ConnectCddEmpReceiverNeedFuSortComponent.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    style: PropTypes.shape({
        padding: PropTypes.string,
        border: PropTypes.string,
        borderRadius: PropTypes.string,
        boxShadow: PropTypes.string,
        transition: PropTypes.string
    }).isRequired
};

export default ConnectCddEmpReceiverNeedFuSortComponent; 